const LOCALE_KEY = "ep.locale"

export type Locale = "fr" | "en"

export const SUPPORTED_LOCALES: Locale[] = ["fr", "en"]
export const DEFAULT_LOCALE: Locale = "fr"

export function readLocale(): Locale {
  const raw = localStorage.getItem(LOCALE_KEY)
  if (raw === "fr" || raw === "en") {
    return raw
  }
  return DEFAULT_LOCALE
}

export function writeLocale(locale: Locale) {
  localStorage.setItem(LOCALE_KEY, locale)
}
